// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import axios from 'axios';
// import Swal from 'sweetalert2';


// export default function ResetPasswordLink() {
//     const location = useLocation();
//     const [otp, setOtp] = useState('');
//     const [token, setToken] = useState('');
//     const [loading, setLoading] = useState(false);

//     // Extract token from URL query string
//     useEffect(() => {
//         const params = new URLSearchParams(location.search);
//         const resetToken = params.get('token');
//         if (resetToken) setToken(resetToken);
//     }, [location.search]);

//     // Handle OTP verification
//     const handleVerifyOTP = () => {
//         if (!otp || !token) {
//             return Swal.fire('Error', 'OTP or token missing', 'error');
//         }

//         setLoading(true);

//         axios.post('https://django-backend-115705416374.asia-south1.run.app//api/password-reset/confirm-with-otp/', { otp, token })
//             .then(res => {
//                 Swal.fire({
//                     icon: 'success',
//                     title: 'OTP Verified',
//                     text: res.data.message || 'A temporary password has been sent to your email.',
//                 });
//                 setOtp(''); // Clear input
//             })
//             .catch(err => {
//                 Swal.fire({
//                     icon: 'error',
//                     title: 'Verification Failed',
//                     text: err.response?.data?.error || 'Invalid OTP or token expired.',
//                 });
//             })
//             .finally(() => setLoading(false));
//     };

//     return (
//         <div className="auth-box">
//             <h2>OTP Validation</h2>
//             <input
//                 type="text"
//                 placeholder="Enter Your OTP Here"
//                 value={otp}
//                 onChange={(e) => setOtp(e.target.value)}
//             />
//             <button onClick={handleVerifyOTP} disabled={loading}>
//                 {loading ? 'Verifying...' : 'Verify OTP'}
//             </button>
//         </div>
//     );
// }


import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';

export default function ResetPasswordLink() {
    const location = useLocation();
    const navigate = useNavigate();
    const [otp, setOtp] = useState('');
    const [token, setToken] = useState('');
    const [loading, setLoading] = useState(false);
    const [verified, setVerified] = useState(false);

    // Extract token from URL query string
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const resetToken = params.get('token');
        if (resetToken) setToken(resetToken);
    }, [location.search]);

    // Handle OTP verification
    const handleVerifyOTP = () => {
        if (!otp.trim() || !token) {
            return Swal.fire('Error', 'OTP or token missing', 'error');
        }

        setLoading(true);

        axios.post('https://django-backend-115705416374.asia-south1.run.app/api/password-reset/confirm-with-otp/', { otp: otp.trim(), token })
        // axios.post('http://localhost:8000/api/password-reset/confirm-with-otp/', { otp: otp.trim(), token })
            .then(res => {
                Swal.fire({
                    icon: 'success',
                    title: 'OTP Verified',
                    text: res.data.message || 'A temporary password has been sent to your email.',
                }).then(() => {
                    setVerified(true);
                    // Redirect to LoginSelection screen
                    window.location.href = '/';
                });
            })
            .catch(err => {
                Swal.fire({
                    icon: 'error',
                    title: 'Verification Failed',
                    text: err.response?.data?.error || 'Invalid OTP or token expired.',
                });
                // Stay on same page on error - no redirect
            })
            .finally(() => setLoading(false));
    };

    return (
        <div className="container">
        <img draggable={false} src="/Main.png" alt="STL Logo" className="logo" />
        <div className="reset-password-box"> {/* Use the new class */}
            <h2>OTP Validation</h2>
            <input
                type="text"
                placeholder="Enter Your OTP Here"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                disabled={verified}
            />
            <button onClick={handleVerifyOTP} disabled={loading || verified}>
                {loading ? 'Verifying...' : 'Verify OTP'}
            </button>
        </div>
        </div>
    );
}

